var map = {
	"./cup.png": "e1a9",
	"./infoItem01.png": "35aa",
	"./infoItem02.png": "e18b",
	"./infoItem03.png": "e86b",
	"./mouse.png": "5105",
	"./mouse.svg": "845d",
	"./spoon.png": "ae9e",
	"./spoon.svg": "5d67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0236";